module.exports = __webpack_public_path__ + "img/xrp-moon-orig.95bbb759.png";